<div class="px-4 sm:px-6 lg:px-8 h-full flex flex-col w-full">
  <div class="sm:flex sm:items-center pb-4">
    <div class="inline-flex w-full">
      <h1 class="font-semibold leading-6 text-gray-900 !text-3xl place-self-center inline-flex w-full">
        <span>Kassen</span>
        <a (click)="load()" class="place-self-center ml-auto text-base fw-normal">Aktualisieren</a>
      </h1>
    </div>
  </div>
  <div class="inline-flex w-full select-none">
    <div class="mx-auto inline-flex w-full max-w-md">
      <a (click)="setMonth(-1)" class="h-8 w-8 rotate-180">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="m6.05 19l5-7l-5-7H8.5l5 7l-5 7zM12 19l5-7l-5-7h2.45l5 7l-5 7z"/>
        </svg>
      </a>
      <a (click)="setMonth(0)" class="fw-bold text-2xl mx-auto">{{ start | date: "MMMM yyyy" }}</a>
      <a (click)="setMonth(1)" class="h-8 w-8">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="m6.05 19l5-7l-5-7H8.5l5 7l-5 7zM12 19l5-7l-5-7h2.45l5 7l-5 7z"/>
        </svg>
      </a>
    </div>
  </div>
  <div class="flex flex-col overflow-x-auto h-full w-full">
    <div class="mt-8 flex w-full">
      <div class="-mx-4 -my-2 sm:-mx-6 lg:-mx-8 flex w-full">
        <div class="inline-flex w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="w-full">
            <thead class="bg-white">
            <tr>
              <th class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3" scope="col">Gerät</th>
              <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">Kassenöffnung</th>
              <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">Nr.</th>
              <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">Mitarbeiter</th>
              <th class="relative py-3.5 pl-3 pr-4 sm:pr-3" scope="col">
                <span *ngIf="permissionService.CheckPermission(PermissionService.device_cashpointentry_close)"
                      class="sr-only">Schließen</span>
              </th>
            </tr>
            </thead>
            <tbody *ngIf="getGroups().length == 0">
            <tr>
              <td class="bg-gray-50 py-2 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3" colspan="5">
                @if (entries && entries.length == 0) {
                  <span>Keine Kassendaten vorhanden.</span>
                } @else if (entries == undefined) {
                  <span class="animate-pulse">Daten werden geladen...</span>
                } @else if (entries == null) {
                  <span>Es ist ein Fehler aufgetreten.</span>
                }
              </td>
            </tr>
            </tbody>
            <tbody *ngFor="let group of getGroups()" class="bg-white">
            <tr class="border-t border-gray-200">
              <th [ngClass]="{'bg-green-200': group == CashPointEntryState.PreparedForClosing, 'bg-yellow-100': group == CashPointEntryState.Opened}" class="bg-gray-50 py-2 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3"
                  colspan="5"
                  scope="colgroup">
                <div class="flex w-full">
                  @if (group == CashPointEntryState.Closed && selectGroup.selectionMode == SelectionMode.Multiple) {
                    <input id="all-select" type="checkbox" class="place-self-center mr-2"
                           [ngModel]="selectGroup.isAllSelected(grouped_entries[CashPointEntryState.Closed])"
                           (ngModelChange)="selectGroup.setAll(grouped_entries[CashPointEntryState.Closed], $event)">
                  }
                  <label class="place-self-center" for="all-select">{{ CashPointEntryStateLabels[group] }}</label>
                  <a
                    *ngIf="group == CashPointEntryState.PreparedForClosing && permissionService.CheckPermission(PermissionService.device_cashpointentry_close)"
                    [queryParams]="{start: start.toISOString(), end: end.toISOString()}"
                    [routerLink]="['/' + Routes.LocationModule + '/' + LocationRoutes.CashPointsClosingAssistant]"
                    class="place-self-center ml-auto inline-flex gap-x-2 bg-white rounded-lg px-2 py-1 hover:!bg-theme-primary-700 hover:text-white">
                    <span class="place-self-center">Kassen schließen</span>
                    <span class="place-self-center">
                      <svg height="18" viewBox="0 0 256 256" width="18" xmlns="http://www.w3.org/2000/svg"><path

                        d="m244.24 75.76l-32-32a6 6 0 0 0-8.48 8.48L225.51 74H208c-48 0-59.44 27.46-69.54 51.69c-9.43 22.64-17.66 42.33-53 44.16a38 38 0 1 0 .06 12c43.34-2.06 54.29-28.29 64-51.55C159.44 106.53 168 86 208 86h17.51l-21.75 21.76a6 6 0 1 0 8.48 8.48l32-32a6 6 0 0 0 0-8.48M48 202a26 26 0 1 1 26-26a26 26 0 0 1-26 26"/></svg>
                    </span>
                  </a>
                  <div
                    *ngIf="group == CashPointEntryState.Closed && permissionService.CheckPermission(PermissionService.device_cashpointentry_getsummary)"
                    class="select-none place-self-center ml-auto inline-flex divide-gray-100">
                    @switch (selectGroup.selectionMode) {
                      @case (SelectionMode.None) {
                        <a (click)="selectGroup.selectionMode = SelectionMode.Multiple">mehrere auswählen</a>
                      }
                      @case (SelectionMode.Multiple) {
                        <div class="inline-flex divide-x divide-gray-500">
                          <div class="inline-flex gap-x-2 pr-1">
                            <input type="checkbox" id="combined-file" class="!ring-0" [(ngModel)]="combinedFile">
                            <label for="combined-file">Kombinierte Datei</label>
                          </div>
                          <a class="px-1" (click)="downloadMany()">herunterladen</a>
                          <a class="pl-1" (click)="selectGroup.selectionMode = SelectionMode.None">Auswahl beenden</a>
                        </div>
                      }
                    }
                  </div>
                </div>
              </th>
            </tr>
            <tr *ngFor="let entry of grouped_entries[group]"
                [class.bg-gray-100]="group == CashPointEntryState.Closed"
                class="border-t border-gray-300 relative tr-safari-relative">
              <td [class.text-gray-500]="!entry.device.serialNumber"
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
                <div class="inline-flex">
                  <div *ngIf="selectGroup.selectionMode == SelectionMode.Multiple && group == CashPointEntryState.Closed"
                       class="place-self-center inline-flex">
                    <div (click)="selectGroup.toggle(entry)" class="absolute inset-0 z-10"></div>
                    <input [ngModel]="selectGroup.isSelected(entry)" class="mr-2 place-self-center" type="checkbox">
                  </div>
                  <span class="place-self-center">
                    {{ entry.device.serialNumber ? devices[entry.device.serialNumber].name : "Gerätename nicht verfügbar" }}
                  </span>
                </div>
              </td>
              <td
                class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ entry.created | date: "dd.MM.yyyy HH:mm" }}
              </td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                <span *ngIf="entry.closingNumber">{{ entry.closingNumber }}</span>
              </td>
              <td
                class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ entry.employeeId && employees[entry.employeeId] ? employees[entry.employeeId].name : "-" }}
              </td>
              <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
                <a
                  (click)="closing = entry"
                  *ngIf="group == CashPointEntryState.PreparedForClosing && permissionService.CheckPermission(PermissionService.device_cashpointentry_close)">schließen</a>
                <a (click)="download(entry)"
                   *ngIf="group == CashPointEntryState.Closed && permissionService.CheckPermission(PermissionService.device_cashpointentry_summary)"
                   class="">Bericht</a>
              </td>
            </tr>
            <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Closing Popup -->
<div *ngIf="closing && permissionService.CheckPermission(PermissionService.Permissions_CashPointCloseAction())"
     class="absolute inset-0">
  <div (click)="closing = undefined" class="absolute inset-0 bg-gray-800 opacity-75 cursor-pointer"></div>
  <div
    class="absolute w-full max-w-2xl left-1/2 -translate-x-1/2 bg-white top-1/2 -translate-y-1/2 rounded-xl p-4 flex flex-col">
    <div class="w-full pb-2 inline-flex">
      <span class="fw-bold text-xl">Kasse schließen</span>
      <span class="mt-auto ml-auto truncate text-ellipsis text-gray-500">{{ closing.device.name }}</span>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div class="w-full flex flex-col gap-y-1">
        <span class="text-lg w-full border-b-2 mb-2">Zahlungsarten</span>
        <div *ngFor="let bookingType of getBookingTypes()" class="inline-flex">
          <span>{{ BookingTypeLabels[bookingType] }}</span>
          <span class="ml-auto">{{ closing_summary[bookingType] | currency: "EUR" }}</span>
        </div>
        <span class="text-lg w-full border-b-2 mb-2 pt-4">Geschäftsvorfälle</span>
        <div *ngFor="let businessCaseType of getBusinessCaseTypes()" class="inline-flex font-light">
          <span>{{ BusinessCaseTypeLabels[businessCaseType] }}</span>
          <span class="ml-auto">{{ closing_business_case_types[businessCaseType] | currency: "EUR" }}</span>
        </div>
      </div>
      <div class="w-full flex flex-col gap-y-1">
        <span class="text-lg w-full border-b-2 mb-2">Kassenbestand</span>
        <div class="inline-flex">
          <span>Soll</span>
          <span class="ml-auto">{{ getValueOrZero(closing_summary[BookingType.Cash]) | currency: "EUR" }}</span>
        </div>
        <div class="grid grid-cols-5 gap-x-4">
          <span class="my-auto col-span-2">Ist</span>
          <app-currency-input [(input)]="actual" [negative]="false" [placeholder]="(getValueOrZero(closing_summary[BookingType.Cash]) | number: '1.2-2')!"
                              class="col-span-3"></app-currency-input>
        </div>
        <div class="grid grid-cols-5 gap-x-4">
          <span class="my-auto col-span-2">Differenz</span>
          <app-currency-input [colored]="true" [input]="(actual ?? getValueOrZero(closing_summary[BookingType.Cash])) - (getValueOrZero(closing_summary[BookingType.Cash]))" [negative]="true" [readonly]="true"
                              class="col-span-3"></app-currency-input>
        </div>
        <div class="grid grid-cols-5 gap-x-4">
          <span class="my-auto col-span-2">Kommentar</span>
          <textarea [(ngModel)]="comment" [minLength]="4" class="col-span-3 border-2 rounded-md -mr-1"></textarea>
        </div>
      </div>
      <div class="w-full flex flex-col gap-y-1 md:col-start-2">
        <span class="text-lg w-full border-b-2 mb-2">Geldtransit</span>
        <span class="text-sm text-gray-500 mb-1" data-testid="geldtransit-hint">Ein positiver Betrag ist eine Abschöpfung (Bargeld verlässt die Kasse), ein negativer Betrag oder ein Endbestand über dem Ist eine Einlage.</span>
        <div class="grid grid-cols-5 gap-x-4">
          <span class="my-auto col-span-2">Betrag</span>
          <app-currency-input [(input)]="skimming_difference" [negative]="true" [placeholder]="((actual ?? getValueOrZero(closing_summary[BookingType.Cash])) - (skimming_result ?? (actual ?? getValueOrZero(closing_summary[BookingType.Cash]))  - (skimming_difference ?? 0)) | number: '1.2-2')!"
                              [readonly]="skimming_result != null"
                              class="col-span-3"></app-currency-input>
        </div>
        <div class="grid grid-cols-5 gap-x-4">
          <span class="my-auto col-span-2">Endbestand</span>
          <app-currency-input [(input)]="skimming_result" [negative]="false" [placeholder]="((actual ?? getValueOrZero(closing_summary[BookingType.Cash]))  - (skimming_difference ?? 0) | number: '1.2-2')!"
                              [readonly]="skimming_difference != null"
                              class="col-span-3"></app-currency-input>
        </div>
      </div>
    </div>
    <div class="inline-flex w-full pt-6">
      <a (click)="closing = undefined" class="place-self-center">Abbrechen</a>
      <button (click)="close()"
              class="-mr-1 bg-white border-theme-primary-700 text-center px-2 py-1 rounded-lg ml-auto border-2 text-theme-primary-700 hover:!bg-theme-primary-700 hover:text-white cursor-pointer">
        Bestätigen
      </button>
    </div>
  </div>
</div>
